import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Upload: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to category selection page
    navigate('/upload/category', { replace: true });
  }, [navigate]);

  return null;
};

export default Upload;
